module.exports = __webpack_public_path__ + "static/logo_fp_transparent.9646b0d2.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/logo_fp_transparent.png
// module id = 566
// module chunks = 15